import { useEffect, useRef, useState } from "react";

/**
 * Canonical filter dropdown for StandardTable top bars.
 * Use this everywhere — do not inline search-input + menu markup per page.
 */
const StandardTableFilterDropdown = ({
  label,
  value = "",
  options = [],
  allLabel,
  onChange,
  alwaysShowLabelPrefix = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const rootRef = useRef(null);

  const selectedOption = options.find(
    (option) => String(option.value) === String(value),
  );
  const hasSelection = Boolean(selectedOption);
  const selectionLabel = selectedOption?.label || allLabel || label;

  const triggerLabel = alwaysShowLabelPrefix
    ? `${label} : ${selectionLabel}`
    : hasSelection
      ? `${label} : ${selectedOption.label}`
      : label;

  useEffect(() => {
    if (!isOpen) return undefined;

    const handleClickOutside = (event) => {
      if (rootRef.current && !rootRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen]);

  const selectValue = (nextValue) => {
    onChange?.(nextValue);
    setIsOpen(false);
  };

  return (
    <div className="table-standard-filter-dropdown" ref={rootRef}>
      <button
        type="button"
        className="search-input table-standard-filter-dropdown__trigger"
        aria-expanded={isOpen}
        aria-haspopup="listbox"
        onClick={(event) => {
          event.stopPropagation();
          setIsOpen((open) => !open);
        }}
      >
        <span className="table-standard-filter-dropdown__trigger-label">
          {triggerLabel}
        </span>
        <i
          className={`fas fa-chevron-${isOpen ? "up" : "down"} table-standard-filter-icon`}
          aria-hidden
        />
      </button>
      {isOpen ? (
        <div className="table-standard-filter-dropdown__menu" role="listbox">
          {allLabel ? (
            <button
              type="button"
              className="table-standard-filter-dropdown__item"
              role="option"
              aria-selected={!hasSelection}
              onClick={(event) => {
                event.stopPropagation();
                selectValue("");
              }}
            >
              {allLabel}
            </button>
          ) : null}
          {options.map((option) =>
            option?.value == null || option.value === "" ? null : (
              <button
                key={String(option.value)}
                type="button"
                className="table-standard-filter-dropdown__item"
                role="option"
                aria-selected={String(option.value) === String(value)}
                onClick={(event) => {
                  event.stopPropagation();
                  selectValue(option.value);
                }}
              >
                {option.label}
              </button>
            ),
          )}
        </div>
      ) : null}
    </div>
  );
};

export default StandardTableFilterDropdown;
